<template>
    <div class="wwdheader" :class="{'inverse' : inverse}">
        <div class="logo-container">
            <router-link :to="`/${$i18n.locale}`">
                <img src="~@/assets/wijwetendingen_logo_white.png" class="logo" v-if="inverse" />
                <img src="~@/assets/wijwetendingen_logo_black.png" class="logo" v-else />
            </router-link>

            <span>{{ $t('subtitle') }}</span>
        </div>

        <nav>
            <ul v-if="routes">
                <li v-for="route in routes" :key="route.id">
                    <router-link :to="`/${$i18n.locale}/${route.url}`">{{route.title}}</router-link>
                </li>
            </ul>
            <locale-changer></locale-changer>
        </nav>
    </div>
</template>

<script>
import LocaleChanger from "./LocaleChanger";

export default {
    components: { LocaleChanger },
    props: {
        inverse: Boolean
    },
    computed: {
        routes: function() {
            return this.$i18n.messages[this.$i18n.locale].routes.filter(
                r => r.display_in_navigation
            );
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.wwdheader {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 3fr;

    @media screen and (max-width: 950px) {
        grid-template-columns: 1fr;
    }
    // z-index: 1;

    .logo-container {
        width: 100%;

        .logo {
            max-width: 170px;

            margin-bottom: 15px;
        }
    }

    .logo-container {
        display: flex;
        flex-direction: column;

        span {
            font-size: 18px;
            font-weight: bolder;

            transform: rotate(-2.5deg);
            color: black;
            text-transform: uppercase;
        }
    }

    nav {
        padding-left: 15px;

        display: flex;
        justify-content: space-around;
        // align-items: flex-start;

        @media screen and (max-width: 950px) {
            padding: 0;

            margin-top: 30px;
        }

        @media screen and (max-width: 950px) {
            flex-direction: column;
        }

        ul {
            flex-grow: 1;
            list-style-type: none;
            display: flex;
            justify-content: space-around;
            // height: 36px;
            // align-items: center;

            @media screen and (max-width: 950px) {
                flex-direction: column;
            }

            li {
                display: flex;
                height: 36px;
                align-items: center;
                @media screen and (max-width: 950px) {
                    margin-top: 15px;
                }

                a {
                    text-decoration: none;
                    font-weight: bold;
                    color: black;
                    text-transform: uppercase;

                    font-size: 14px;

                    cursor: pointer;
                }
            }
        }
    }

    &.inverse {
        color: white;
        nav ul li a {
            color: white;
        }

        .logo-container span {
            color: white;
        }
    }
}
</style>
